<template>
  <div class="zcy-list">
    <div class="hd">
      {{ title }}
      <a-button v-if="isSearching" class="reset-btn" @click="reset">重置</a-button>
    </div>
    <div class="bd">
      <a-spin :spinning="isLoading">
        <div class="list-wrap" v-if="hasData">
          <ul class="list-container">
            <li class="list-item" v-for="(item, index) in list" :key="index">
              <a class="item-link" :href="`/detail.html?id=${item.id}`">
                <div class="left" :title="item.districtType">
                  <span class="left-title">{{ item.districtType }}</span>
                </div>
                <div class="mid" v-html="item.title"></div>
                <div class="right">
                  <app-icon type="iconshijian" />
                  {{ item.date }}
                </div>
              </a>
            </li>
          </ul>
          <div class="pagination-wrap">
            <a-pagination showQuickJumper :current="current" :pageSize="15" :total="total" @change="onChange" />
          </div>
        </div>
        <div class="list-empty" v-else></div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import AppIcon from '@/components/icon';
export default {
  name: 'zcy-list',
  components: {
    'app-icon': AppIcon
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    changePage: {
      type: Function,
      default: function () {}
    },
    isLoading: {
      type: Boolean,
      default: () => true
    },
    title: {
      type: String,
      default: () => '公开招标公告'
    },
    isSearching: {
      type: Boolean,
      default: () => false
    },
    current: {
      type: Number,
      default: () => 1
    },
    reset: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    onChange (page) {
      console.log(`current page: ${page}`);
      this.changePage(page);
    }
  },
  computed: {
    hasData () {
      return this.list.length > 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/index/list.vue